import * as styles from "./Panel.css";

import { clsx } from "clsx";
import type { CSSProperties, JSX } from "react";

import { vars } from "@frontend/styles";

import type { PanelProps } from "./Panel.types";

function colorMix(
  color: string,
  percent: number,
  mixWith: string,
): CSSProperties["borderColor"] {
  return `color-mix(in srgb, ${color} ${percent}%, ${mixWith})`;
}

function toneStyle(
  color: string | undefined,
  borderPercent: number,
  backgroundPercent: number,
): CSSProperties | undefined {
  return color
    ? {
        borderColor: colorMix(color, borderPercent, vars.color.border),
        backgroundColor: colorMix(color, backgroundPercent, "transparent"),
      }
    : undefined;
}

export function Panel({
  width = "fill",
  padding,
  margin,
  border = "solid",
  overflow = "clip",
  color,
  className,
  contentClassName,
  ringRef,
  style,
  children,
  ...props
}: PanelProps): JSX.Element {
  if (border !== "solid") {
    return (
      <div
        ref={ringRef}
        className={clsx(
          styles.ring,
          border === "glass" && styles.ringGlass,
          styles.widthVariants[width],
          styles.marginVariants[margin ?? "none"],
          className,
        )}
        style={toneStyle(color, 25, 6)}
      >
        <div
          data-slot="panel"
          className={clsx(
            styles.panel({ padding, border, overflow }),
            styles.panelFillsRing,
            contentClassName,
          )}
          style={{ ...toneStyle(color, 55, 10), ...style }}
          {...props}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      data-slot="panel"
      className={clsx(
        styles.panel({ padding, border, overflow }),
        styles.widthVariants[width],
        styles.marginVariants[margin ?? "none"],
        contentClassName,
        className,
      )}
      style={{ ...toneStyle(color, 55, 10), ...style }}
      {...props}
    >
      {children}
    </div>
  );
}
